import React, { useState, useEffect } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { useSelector } from "react-redux";

const InstructorAttendance = () => {
  const [attendanceHistory, setAttendanceHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(false);
  const [checkInTime, setCheckInTime] = useState("");

  const { user } = useSelector((state) => state.users);
  const instructorId = user?.id;
  const todayDate = new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (instructorId) {
      fetchHistory();
    }
  }, [instructorId]);

  const fetchHistory = async () => {
    try {
      const res = await axiosInstance.get("/instructor/attendance", {
        params: { instructorId },
      });
      setAttendanceHistory(res.data.data);
    } catch (err) {
      console.error("Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const markCheckIn = async () => {
    if (!checkInTime) return;
    setMarking(true);
    try {
      const payload = {
        instructorId,
        date: todayDate,
        status: "Present",
        checkInTime,
      };
      await axiosInstance.post("/instructor/attendance", payload);
      alert("Check-In recorded!");
      setCheckInTime("");
      fetchHistory();
    } catch (err) {
      console.error("Check-In Error:", err);
      alert(err.response?.data?.message || "Check-in failed");
    } finally {
      setMarking(false);
    }
  };

  const handleRowCheckOut = async (record, index) => {
    const checkOutTime = record.manualCheckOut;
    if (!checkOutTime) return;

    setMarking(true);
    try {
      const payload = {
        instructorId,
        date: record.date,
        status: record.status || "Present",
        checkOutTime,
        checkInTime: null, // To avoid duplicate check-in creation
      };

      await axiosInstance.post("/instructor/attendance", payload);
      alert("Check-Out recorded!");
      fetchHistory();
    } catch (err) {
      console.error("Check-Out Error:", err);
      alert(err.response?.data?.message || "Check-out failed");
    } finally {
      setMarking(false);
    }
  };

  return (
    <div>
      <p className="paragraph-css">Instructor Attendance</p>
      {loading ? (
        <Loading />
      ) : (
        <div>
          {/* ✅ Top Check-In Form */}
          <div className="flex flex-col mb-6">
            <label className="ml-2">Check-In Time:</label>
            <div className="flex items-center gap-2 mt-2">
              <input
                type="time"
                value={checkInTime}
                onChange={(e) => setCheckInTime(e.target.value)}
                className="!w-[200px]"
              />
              <button
                className="bg-[#264b82] text-white py-2 px-4 rounded-md shadow"
                onClick={markCheckIn}
                disabled={marking || !checkInTime}
              >
                Mark Check-In
              </button>
            </div>
          </div>

          {/* ✅ Attendance Table */}
          <div className="instructor-table">
            {attendanceHistory.length === 0 ? (
              <h2 className="no-data-found">No data found</h2>
            ) : (
              <table className="table-width-100">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Check-In Time</th>
                    <th>Check-Out Time</th>
                  </tr>
                </thead>
                <tbody>
                  {attendanceHistory.map((record, index) => (
                    <tr key={index}>
                      <td className="cell">
                        {new Date(record.date).toLocaleDateString()}
                      </td>
                      <td className="cell">{record.status}</td>
                      <td className="cell">{record.checkInTime || "N/A"}</td>
                      <td className="cell">
                        {record.checkOutTime ? (
                          record.checkOutTime
                        ) : (
                          <div className="flex items-center gap-1">
                            <input
                              type="time"
                              className="!w-[180px]"
                              value={record.manualCheckOut || ""}
                              onChange={(e) => {
                                const updated = [...attendanceHistory];
                                updated[index].manualCheckOut = e.target.value;
                                setAttendanceHistory(updated);
                              }}
                            />
                            <button
                              className="bg-green-600 text-white px-2 py-1 rounded"
                              onClick={() => handleRowCheckOut(record, index)}
                              disabled={!record.manualCheckOut}
                            >
                              Check-Out
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default InstructorAttendance;
